import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import TagsSelector from './TagsSelector/TagsSelector'
import {
  getCategoryOptions,
  getMenuItems,
  getProductCategoriesFilterLabel,
  getProductTagsFilterLabel,
  getProductTypeOptions,
  getProductTypesFilterLabel,
  isFilteringByProductCategories,
  isFilteringByProductTags,
  isFilteringByProductTypes,
} from './helpers'
import * as Styles from './styles'

const FilterProductsSelector = ({
  returnReasonsFiltering,
  availabilityMode,
  onChangeAvailabilityMode,
  productTypes,
  selectedProductTypes,
  onChangeProductTypes,
  categories,
  selectedCategories,
  onChangeCategories,
  tags,
  onChangeTags,
  matchCase,
  onChangeMatchCase,
}) => {
  const { t } = useTranslation()

  const handleChangeFilter = e => {
    const value = e.target.value

    onChangeAvailabilityMode(value)

    if (!isFilteringByProductTypes(value)) onChangeProductTypes([])
    if (!isFilteringByProductCategories(value)) onChangeCategories([])
    if (!isFilteringByProductTags(value)) {
      onChangeTags([])
      onChangeMatchCase(false)
    }
  }

  const handleChangeProductTypes = e => {
    onChangeProductTypes(e.target.value)
  }

  const handleChangeCategories = e => {
    onChangeCategories(e.target.value)
  }

  const menuItems = getMenuItems(returnReasonsFiltering, t)

  return (
    <Styles.Container>
      <div>
        <ComboBox
          fullWidth
          menuItems={menuItems}
          label={t('Disponible para')}
          value={availabilityMode}
          handleChange={handleChangeFilter}
        />
      </div>
      {isFilteringByProductTypes(availabilityMode) && (
        <ComboBox
          fullWidth
          multiple
          menuItems={getProductTypeOptions(productTypes)}
          label={t(getProductTypesFilterLabel(availabilityMode))}
          value={selectedProductTypes}
          handleChange={handleChangeProductTypes}
        />
      )}
      {isFilteringByProductCategories(availabilityMode) && (
        <ComboBox
          fullWidth
          multiple
          menuItems={getCategoryOptions(categories)}
          label={t(getProductCategoriesFilterLabel(availabilityMode))}
          value={selectedCategories}
          handleChange={handleChangeCategories}
        />
      )}
      {isFilteringByProductTags(availabilityMode) && (
        <TagsSelector
          label={t(getProductTagsFilterLabel(availabilityMode))}
          tags={tags}
          onChangeTags={onChangeTags}
          matchCase={matchCase}
          onChangeMatchCase={onChangeMatchCase}
        />
      )}
    </Styles.Container>
  )
}

export default FilterProductsSelector
